import * as React from 'react';

import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  TextField,
  DateField,
  required,
} from 'react-admin';

export const RepTitlesList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="rank" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);

export const RepTitlesCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" validate={required()} />
      <TextInput source="rank" validate={required()} />
    </SimpleForm>
  </Create>
);

export const RepTitlesEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" validate={required()} />
      <TextInput source="rank" validate={required()} />
    </SimpleForm>
  </Edit>
);
